import {
  RaydiumLiquidityPool,
  solanaConstantsStore,
} from "../state/flowchart-store";
import { utils as splUtils } from "@malloc-protocol/spl";

export const getAllRaydiumPools = async (): Promise<RaydiumLiquidityPool[]> => {
  const getCached = async () => {
    if (solanaConstantsStore.state.raydium.liquidityPools)
      return solanaConstantsStore.state.raydium.liquidityPools;
    const pools = await splUtils.raydium.getMainnetRaydiumPools();

    solanaConstantsStore.setState({
      ...solanaConstantsStore.state,
      raydium: {
        ...solanaConstantsStore.state.raydium,
        liquidityPools: pools,
      },
    });
    return pools;
  };
  const pools = await getCached();
  return pools;
};
